import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

import { ENDPOINTS } from "utils/endpoints";
import { checkNestedObject } from "utils/checkNestedObject";
import { media } from "utils/style";
import { setBaseURLForNonSecure } from "../../../../Services/API";
import { setA11yContent } from "../NavigationHelper/actions";
import { fetchPageContent } from "../DownloadAndDelete/actions";

import RectangleLoader from "common-components/RectangleLoader";
import { ButtonWithArrow } from "common-components/Buttons";

class LoginPage extends Component {
  state = {
    loading: true,
    iFrameLoading: true
  };

  componentDidMount() {
    setBaseURLForNonSecure();
    this.props.fetchPageContent(ENDPOINTS.FETCH_SIGNIN_PAGE).then(() => {
      this.setState({ loading: false });

      if (checkNestedObject(this.props.pageContent, "sc_pagetitle")) {
        this.props.setA11yContent(
          "login page",
          this.props.pageContent.sc_pagetitle,
          this.props.pageContent.seo_description
        );
      }
      const loginIframe = document.getElementById("login_iframe");

      if (loginIframe) {
        loginIframe.addEventListener("load", () => {
          this.setState({ iFrameLoading: false });
        });
      } else {
        this.setState({ iFrameLoading: false });
      }
    });
  }

  handleClick = link => {
    window.location = link;
  };

  render() {
    if (this.state.loading) {
      return <RectangleLoader />;
    }
    const {
      links,
      richText: [{ title, description }]
    } = this.props.pageContent.signin_page.collist[1];
    const { genericList } = this.props.pageContent.signin_page.collist[0];

    return (
      <Container>
        {this.state.iFrameLoading ? (
          <IFrameLoader>
            <RectangleLoader />
          </IFrameLoader>
        ) : null}
        <GridItem>
          <div className="sign_in_div">
            <iframe
              id="login_iframe"
              style={{ height: "600px", width: "100%", overflow: "hidden" }}
              title="sign_in"
              scrolling="no"
              src={window.reactGlobals.loginPageIframeUrl}
            ></iframe>
            <P>
              {genericList[1].list[0].jsonKey}{" "}
              <Link to="/privacy/your-data/guest-landing">{genericList[1].list[1].jsonKey}</Link>
            </P>
          </div>
        </GridItem>

        <GridItem registerDiv>
          <h2>{title}</h2>
          <p>{description}</p>

          {links.map(({ link, text }, index) => (
            <Div key={index}>
              <ButtonWithArrow role="link" onClick={() => this.handleClick(link)}>
                {text}
              </ButtonWithArrow>
            </Div>
          ))}
        </GridItem>
      </Container>
    );
  }
}

const mapStateToProps = ({ loadingAndErrorState: { loading }, pageContent }) => ({
  loading,
  pageContent
});

LoginPage.propTypes = {
  setA11yContent: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired
};

export default connect(
  mapStateToProps,
  { setA11yContent, fetchPageContent }
)(LoginPage);

const IFrameLoader = styled.div`
  position: absolute;
  top: -35px;
  right: 0;
  left: 0;
  bottom: 0;
  background: #fff;
`;

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  max-width: 1070px;
  margin: 80px auto;
  padding: 0 20px;

  ${media.mobile`
    margin: 40px auto;
    padding: 0 16px;
  `}
`;

const P = styled.p`
  margin-top: 50px;

  ${media.mobile`
    margin: 40px 0;
  `}
`;
const Div = styled.div`
  margin: 15px 0 15px 0;
`;

const GridItem = styled.div`
  flex-basis: 50%;

  .sign_in_div {
    max-width: 80%;
  }

  ${({ registerDiv }) =>
    registerDiv &&
    `
    p {
      margin: 24px 0;
      max-width: 385px;
    }

    ul {
      list-style: disc inside;
    }

    li {
      margin: 10px 0;
    }

  	p, ul {
      font-size: 16px;
      line-height: 16px;
    }
  `}

  ${media.mobile`
    flex-basis: 100%;

    ul {
      list-style: disc;
      padding: 0 20px;
    }

    p, ul {
      font-size: 14px;
      line-height: 16px;
    }

    .sign_in_div {
      max-width: 100%;
    }
  `}
`;
